export default __webpack_public_path__ + "static/media/bg-banner.84890ced.png";